import CourseList from '../components/course-list';
import { Link } from 'react-router-dom';
import { Trophy, ChevronDown, Mail } from 'lucide-react';
import { useWorkspace } from '../context/workspace-context';
import { useUnreadCount } from '../hooks/use-notifications';

const CoursesPage = () => {
  const {
    currentWorkspace,
    availableWorkspaces,
    switchWorkspace,
    canSwitchWorkspaces,
  } = useWorkspace();

  const { data: unreadData } = useUnreadCount();
  const unreadCount = unreadData?.count ?? 0;

  return (
    <div className="flex flex-col min-h-screen max-w-lg mx-auto bg-bg-main px-4 py-6">
      <header className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-xl font-bold text-title">My Courses</h1>
          <div className="flex items-center gap-3">
            <Link
              to="/notifications"
              className="relative text-title hover:text-accent-purple transition-colors"
            >
              <Mail className="w-6 h-6" />
              {unreadCount > 0 && (
                <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </Link>
            <Link
              to="/leaderboard"
              className="text-title hover:text-accent-purple transition-colors"
            >
              <Trophy className="w-6 h-6" />
            </Link>
          </div>
        </div>

        {/* Org Switcher - Only for Super Admins with multiple orgs */}
        {canSwitchWorkspaces && availableWorkspaces.length > 1 && (
          <div className="relative inline-flex items-center">
            <select
              value={currentWorkspace?.id.toString() ?? ''}
              onChange={(e) => switchWorkspace(parseInt(e.target.value))}
              className="appearance-none bg-transparent text-sm text-subheading pr-6 cursor-pointer focus:outline-none"
            >
              {availableWorkspaces.map((workspace) => (
                <option key={workspace.id} value={workspace.id.toString()}>
                  {workspace.name}
                </option>
              ))}
            </select>
            <ChevronDown className="absolute right-0 w-4 h-4 text-subheading pointer-events-none" />
          </div>
        )}
      </header>

      <main className="flex-1">
        <CourseList />
      </main>
    </div>
  );
};

export default CoursesPage;
